// Column keys double as the backend sort keys (CommitteeFilters::SORTABLE).
export function buildColumns() {
  return [
    { key: 'name', label: 'Committee Name', sortable: true, minWidth: '200px', width: '1fr' },
    { key: 'switch', label: 'Action', width: '80px', cellClass: 'text-center' }
  ]
}

// Two short columns: the desktop layout stays as-is on narrow screens (no accordion needed).
export function buildBreakpoints() {
  return []
}



// WEBPACK FOOTER //
// ./src/views/Committees/Switch/switchCommitteeColumns.js